'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Checked(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#00B083' : _ref$color,
      circle = _ref.circle;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 20 20',
      version: '1.1',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('rect', { x: 0, y: 0, width: 20, height: 20, rx: 4 })
    ),
    _react2.default.createElement(
      'g',
      {
        transform: 'translate(-2.000000, -2.000000)',
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement(
        'g',
        { transform: 'translate(2.000000, 2.000000)' },
        circle ? _react2.default.createElement('rect', { fill: color, x: 0, y: 0, width: 20, height: 20, rx: 50 }) : _react2.default.createElement('rect', {
          x: 0,
          y: 0,
          width: 66,
          height: 66,
          transform: 'translate(-21.000000, -21.000000)',
          fill: color
        })
      ),
      _react2.default.createElement('path', {
        d: 'M5.295 12.507a1.844 1.844 0 0 1-.005-2.509 1.598 1.598 0 0 1 2.345-.005l3.04 3.128 5.69-6.01a1.598 1.598 0 0 1 2.29-.054l.055.058a1.844 1.844 0 0 1-.005 2.51l-6.868 7.266a1.6 1.6 0 0 1-2.29.05l-.056-.056a1.833 1.833 0 0 1-.13-.156l-4.066-4.222z',
        fill: '#FFF'
      })
    )
  );
}

Checked.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  circle: _propTypes2.default.bool
};

exports.default = Checked;